import React, { Component } from "react";
import "./testingPage.scss";
import {
  checkAppStatus,
  checkCamerasInternalIps,
  checkCamerasRtspPorts,
  checkCommunicationFile,
  checkDnsIpCompare,
  checkDockerImages,
  checkExternalPorts,
  checkIsOnline,
  checkOutsideAccess,
  checkSshConnection,
  checkTrackingCamera,
  checkVersions,
  checkScoreCamera,
  checkDisplayDongleExist
} from "../../utils/testing-api";
import { ReactComponent as OfflineIcon } from "../../assets/imgs/offline.svg";
import { ReactComponent as TestingIcon } from "../../assets/imgs/testing.svg";
import { SiteList, SiteTestsGrid } from "../../components/index";
import { getSitesList } from "../../utils/site-api";
import I18N from "../../I18N";
import { cameraControl } from "@myplay/all";
import ReactLoading from "react-loading";

const { live } = cameraControl;

const MVP_URL = "https://myplay-assets.gcdn.co/mvp/production/index.html?live=";
const LIVE_MODAL_TIME = 18000;

const OffLineSite = () => {
  return (
    <div className="offline-site">
      <p>{I18N.t("SITE_OFFLINE")}</p>
      <OfflineIcon />
    </div>
  );
};

const StartTesting = () => {
  return (
    <div className="start-testing">
      <p>{I18N.t("START_TESTING")}</p>
      <TestingIcon />
    </div>
  );
};

class LiveModal extends Component {
  state = {
    isliveReady: false
  };

  async componentDidMount() {
    const { liveSessionId, handleClose } = this.props;
    const cameras = await live.liveAuth(liveSessionId);

    const isMainCameraReady = await live.requestCamerasUntilReadyWithCameras(
      cameras,
      60,
      5000
    );

    // closing modal after 3 minute
    this.setState({ isLiveReady: isMainCameraReady });

    setTimeout(() => {
      handleClose();
    }, LIVE_MODAL_TIME);
  }

  render() {
    const { liveSessionId, handleClose } = this.props;
    const { isLiveReady } = this.state;
    return (
      <div className="live-modal">
        <button className="live-modal__close" onClick={handleClose}>
          X
        </button>
        {isLiveReady ? (
          <iframe
            src={`${MVP_URL}${liveSessionId}`}
            frameBorder={0}
            width={"600px"}
            height={"338px"}
          />
        ) : (
          <div className="live-modal__loader">
            <p>Live Loading...</p>
            <ReactLoading
              type={"bars"}
              color={"#16c4ab"}
              height={60}
              width={120}
            />
          </div>
        )}
      </div>
    );
  }
}

class TestingPage extends Component {
  state = {
    appStatus: {},
    camerasRtspPorts: {},
    camerasInternalIps: {},
    externalPorts: {},
    communicationFile: {},
    versions: {},
    dnsIpCompare: {},
    outSideAccess: {},
    sshConnection: {},
    record: {},
    live: { liveSessionId: null },
    speedtest: {},
    cameraInfo: {},
    dockerImages: {},
    isLoading: false,
    siteList: [],
    siteId: "",
    siteDns: "",
    isOnline: true,
    scoreCamera: {},
    isDongleExist: {}
  };

  async componentDidMount() {
    /* eslint-disable */
    const params = new URLSearchParams(location.search);
    const siteDns = params.get("site");
    try {
      const siteList = await getSitesList();
      this.setState({ siteList });
      if (siteDns) {
        this.handleSiteSelect(siteDns);
      }
    } catch (e) {
      console.log(e);
    }
  }

  resetSiteInfo = () => {
    this.setState({
      appStatus: { isLoading: true },
      camerasRtspPorts: { isLoading: true },
      camerasInternalIps: { isLoading: true },
      externalPorts: { isLoading: true },
      communicationFile: { isLoading: true },
      versions: { isLoading: true },
      dnsIpCompare: { isLoading: true },
      outSideAccess: { isLoading: true },
      sshConnection: { isLoading: true },
      dockerImages: { isLoading: true },
      record: {},
      live: {},
      speedtest: {},
      cameraInfo: { isLoading: true },
      scoreCamera: { isLoading: true },
      isDongleExist: { isLoading: true }
    });
  };

  handleSiteSelect = async siteDns => {
    this.setState({ siteDns });
    const { siteList } = this.state;
    const site = siteList.find(item => Object.keys(item)[0] === siteDns);
    const siteId = site && site[siteDns];
    this.siteId = siteId;

    if (siteId) {
      try {
        this.resetSiteInfo();
        const isOnline = await checkIsOnline(siteId);
        if (isOnline) {
          this.runSiteTests();
        }
        this.setState({ isOnline });
        this.setState({ siteId });
      } catch (e) {
        this.setState({ isOnline: false });
        console.log(e);
      }
    }
  };

  runSiteTests = () => {
    const tests = [
      { testFunc: checkAppStatus, testName: "appStatus" },
      { testFunc: checkCamerasInternalIps, testName: "camerasInternalIps" },
      { testFunc: checkCamerasRtspPorts, testName: "camerasRtspPorts" },
      { testFunc: checkCommunicationFile, testName: "communicationFile" },
      { testFunc: checkDnsIpCompare, testName: "dnsIpCompare" },
      { testFunc: checkExternalPorts, testName: "externalPorts" },
      { testFunc: checkIsOnline, testName: "isOnline" },
      { testFunc: checkOutsideAccess, testName: "outsideAccess" },
      { testFunc: checkSshConnection, testName: "sshConnection" },
      { testFunc: checkTrackingCamera, testName: "trackingCamera" },
      { testFunc: checkVersions, testName: "versions" },
      { testFunc: checkDockerImages, testName: "dockerImages" },
      { testFunc: checkScoreCamera, testName: "scoreCamera" },
      { testFunc: checkDisplayDongleExist, testName: "isDongleExist" }
    ];
    tests.map(test => this.asyncSetStateWrapper(test));
  };

  asyncSetStateWrapper = test => {
    const { testFunc, testName } = test;
    testFunc(this.siteId)
      .then(res => {
        this.setState(res);
      })
      .catch(() => {
        this.setState({ [testName]: { error: true, isLoading: false } });
      });
  };

  handleReTest = async (checkFunc, testName) => {
    const { siteId } = this.state;
    if (siteId) {
      try {
        this.setState({ [testName]: { isLoading: true } });
        const result = await checkFunc(siteId);
        this.setState(result);
      } catch (e) {
        this.setState({ [testName]: { error: true, isLoading: false } });
      }
    }
  };

  render() {
    const { siteList, siteDns, isOnline, siteId, live } = this.state;
    const { liveSessionId } = live;
    const { logout } = this.props;
    return (
      <div className="testing-page">
        <header className="testing-page__header">
          <SiteList
            siteList={siteList}
            siteDns={siteDns}
            onSiteSelect={this.handleSiteSelect}
          />
          <button onClick={logout} className="testing-page__logout-button">
            {I18N.t("LOGOUT")}
          </button>
        </header>
        {isOnline ? (
          siteId ? (
            <SiteTestsGrid
              testsResult={this.state}
              onReTestClick={this.handleReTest}
            />
          ) : (
            <StartTesting />
          )
        ) : (
          <OffLineSite />
        )}
        {liveSessionId && (
          <LiveModal
            liveSessionId={liveSessionId}
            handleClose={() => {
              this.setState({ live: { liveSessionId: null } });
            }}
          />
        )}
      </div>
    );
  }
}

export default TestingPage;
